'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pagination = require('./pagination');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var API = function () {
  function API(apiURL) {
    _classCallCheck(this, API);

    this.apiURL = apiURL;
  }

  _createClass(API, [{
    key: 'headers',
    value: function headers() {
      var _headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return _extends({
        'Content-Type': 'application/json'
      }, _headers);
    }
  }, {
    key: 'parseJsonResponse',
    value: function parseJsonResponse(response) {
      return response.json().then(function (json) {
        if (!response.ok) {
          return Promise.reject(json);
        }

        var pagination = (0, _pagination.getPagination)(response);

        return pagination ? { pagination: pagination, items: json } : json;
      });
    }
  }, {
    key: 'request',
    value: function request(path) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var headers = this.headers(options.headers || {});
      return fetch(this.apiURL + path, _extends({}, options, { headers: headers })).then(function (response) {
        var contentType = response.headers.get('Content-Type');
        if (contentType && contentType.match(/json/)) {
          return _this.parseJsonResponse(response);
        }

        return response.text().then(function (data) {
          if (!response.ok) {
            return Promise.reject({ data: data });
          }

          return { data: data };
        });
      });
    }
  }]);

  return API;
}();

exports.default = API;


//////////////////
// WEBPACK FOOTER
// ../~/micro-api-client/lib/index.js
// module id = 337
// module chunks = 0